export default "__VITE_ASSET__Dxel4SfU__"